"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Init = void 0;
const GraphMonitor_1 = require("./GraphMonitor");
const HRGraph = __importStar(require("./GraphHR"));
const SETTINGS = __importStar(require("../UI/SettingsPanel"));
var hr_bpm = 0;
function Init(id) {
    let bpGraph = new GraphMonitor_1.GraphMonitor(id);
    bpGraph.Y = (x) => graphY(x, bpGraph);
}
exports.Init = Init;
function graphY(x, bp_graph) {
    var _a, _b, _c, _d;
    const settings = SETTINGS.INPUTS;
    const h = bp_graph.HEIGHT, w = bp_graph.WIDTH, dT = bp_graph.nDIVX, maxH = 240;
    const systolic_bpm = ((_a = settings['sys_r']) === null || _a === void 0 ? void 0 : _a.value) != 'undefined' ? Number((_b = settings['sys_r']) === null || _b === void 0 ? void 0 : _b.value) : 120;
    const diastolic_bpm = ((_c = settings['dia_r']) === null || _c === void 0 ? void 0 : _c.value) != 'undefined' ? Number((_d = settings['dia_r']) === null || _d === void 0 ? void 0 : _d.value) : 60;
    const dh = systolic_bpm - diastolic_bpm;
    const RPULSEX = HRGraph.RRPrevX;
    // use the higher HR
    hr_bpm = HRGraph.HR_BPM;
    let rx = 60 * (w / dT) / hr_bpm;
    const pw = 0.1 * rx;
    const pulse_sys = (0, GraphMonitor_1.Pulse)(x, RPULSEX + 2.5 * pw, 1, pw);
    const pulse_dia = (0, GraphMonitor_1.Pulse)(x, RPULSEX + 5.5 * pw, 0.7, 1.3 * pw);
    const pulse = hr_bpm > 0 ? dh * (pulse_sys + pulse_dia) - diastolic_bpm : 0;
    let y = RPULSEX > -1 ? pulse / maxH * h + h : h;
    return y;
}
